<div class="cell shrink">
    <i class="fas fa-exclamation-triangle alertIcon"></i>
</div>
<div class="cell auto">
    <ng-content></ng-content>
</div>
